import {Mapper} from '@s-ui/domain'

export class FromElectricFeaturesRawDataToElectricFeaturesVOMapper extends Mapper {
  constructor({config, valueObject: electricFeaturesValueObjectFactory}) {
    super()
    this._config = config
    this._electricFeaturesValueObjectFactory = electricFeaturesValueObjectFactory
    this._MAIN_MOTOR_TYPE_INDEX = 0
    this._SEPARATOR = ' / '
  }

  setParams = ({summarized}) => {
    this._summarized = !!summarized
    return this
  }

  _getChargingInformation = ({mode}) => {
    if (!mode) return
    const hasDuration = Boolean(mode?.duration)
    return hasDuration
      ? {
          ...(!this._summarized && {amperage: mode?.amps?.value}),
          chargeEnd: mode?.chargeEnd?.value,
          chargeStart: mode?.chargeStart?.value,
          duration: mode?.duration?.value,
          maxKW: mode?.maxKW?.value,
          ...(!this._summarized && {voltage: mode?.voltage?.value})
        }
      : null
  }

  map = ({electricFeatures}) => {
    if (!electricFeatures) return
    const {
      chargingConnector: inputChargingConnector = [],
      chargingInformation = {},
      combinedConsumption = {},
      motorType: inputMotorType = [],
      fuelConsumption = {},
      power = {},
      powerSource = {},
      range = {}
    } = electricFeatures

    const electricChargingTime = this._getChargingInformation({
      mode: chargingInformation?.standardMode
    })
    const fastChargingTime = this._getChargingInformation({
      mode: chargingInformation?.fastMode
    })
    const motorType = inputMotorType && inputMotorType.length > 0 && inputMotorType[this._MAIN_MOTOR_TYPE_INDEX]
    const chargingConnector = inputChargingConnector && inputChargingConnector.join(this._SEPARATOR)

    if (this._summarized) {
      return this._electricFeaturesValueObjectFactory({
        batteryCapacity: powerSource?.maximumBatteryKWH?.value,
        consumptionAverageElectricWltp: combinedConsumption?.value,
        range: range?.value,
        ...(electricChargingTime && {electricChargingTime}),
        ...(fastChargingTime && {fastChargingTime})
      })
    }

    return this._electricFeaturesValueObjectFactory({
      batteryCapacity: powerSource?.maximumBatteryKWH?.value,
      batteryType: powerSource?.batteryType,
      chargingConnector,
      consumptionAverageElectricWltp: combinedConsumption?.value,
      range: range?.value,
      ...(electricChargingTime && {electricChargingTime}),
      ...(fastChargingTime && {fastChargingTime}),
      fuelConsumptionCombined: fuelConsumption?.combined?.value,
      fuelConsumptionStandard: fuelConsumption?.standard,
      maxPower: power?.maxPower?.value,
      ...(motorType && {motorType}),
      onboardCharger: powerSource?.onboardCharger?.value
    })
  }
}
